import React, { useState, useEffect } from 'react';
import axios from '../services/axiosConfig';
import { exportTurnos } from '../utils/exportUtils';
import ConfirmDialog from './ConfirmDialog';
import '../styles/turnos.css';

function Turnos({ mostrarForm = false, onCerrarForm }) {
  const [turnos, setTurnos] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [mostrarFormLocal, setMostrarFormLocal] = useState(mostrarForm);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [turnoEditando, setTurnoEditando] = useState(null);
  const [fechaFiltro, setFechaFiltro] = useState(new Date().toISOString().split('T')[0]);
  const [turnoAEliminar, setTurnoAEliminar] = useState(null);
  const [mostrarConfirmEliminar, setMostrarConfirmEliminar] = useState(false);
  const [formData, setFormData] = useState({
    paciente_id: '',
    fecha_hora: '',
    duracion: 45,
    estado: 'pendiente',
    notas: ''
  });

  const cargarDatos = async () => {
    try {
      console.log('🔄 Cargando datos de turnos y pacientes...');
      const [turnosRes, pacientesRes] = await Promise.all([
        axios.get(`/turnos?fecha=${fechaFiltro}`),
        axios.get('/pacientes')
      ]);
      console.log('📦 Respuesta pacientes:', pacientesRes.data);
      // Manejar respuestas paginadas o arrays directos
      const turnosData = turnosRes.data;
      const pacientesData = pacientesRes.data;
      setTurnos(Array.isArray(turnosData) ? turnosData : (turnosData?.data || []));
      
      // Para pacientes, obtener el array correctamente
      let listaPacientes = [];
      if (Array.isArray(pacientesData)) {
        listaPacientes = pacientesData;
      } else if (pacientesData?.data && Array.isArray(pacientesData.data)) {
        listaPacientes = pacientesData.data;
      }
      console.log('📋 Pacientes cargados:', listaPacientes.length, listaPacientes);
      setPacientes(listaPacientes);
    } catch (error) {
      console.error('❌ Error cargando datos:', error);
      setTurnos([]);
      setPacientes([]);
    }
  };

  useEffect(() => {
    cargarDatos();
    setMostrarFormLocal(mostrarForm);
  }, [fechaFiltro, mostrarForm]);

  const cambiarEstadoTurno = async (turnoId, nuevoEstado) => {
    try {
      await axios.put(`/turnos/${turnoId}/estado`, {
        estado: nuevoEstado
      });
      cargarDatos();
    } catch (error) {
      console.error('Error actualizando turno:', error);
      alert('Error al actualizar el estado del turno');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const datos = {
        ...formData,
        fecha_hora: formData.fecha_hora.includes(':00') ? formData.fecha_hora : `${formData.fecha_hora}:00`
      };
      
      if (modoEdicion) {
        await axios.put(`/turnos/${turnoEditando.id}`, datos);
      } else {
        await axios.post('/turnos', datos);
      }
      
      setMostrarFormLocal(false);
      setModoEdicion(false);
      setTurnoEditando(null);
      if (onCerrarForm) onCerrarForm();
      setFormData({ paciente_id: '', fecha_hora: '', duracion: 45, estado: 'pendiente', notas: '' });
      cargarDatos();
    } catch (error) {
      console.error('Error guardando turno:', error);
      alert('Error al guardar el turno');
    }
  };

  const cerrarModal = () => {
    setMostrarFormLocal(false);
    setModoEdicion(false);
    setTurnoEditando(null);
    setFormData({ paciente_id: '', fecha_hora: '', duracion: 45, estado: 'pendiente', notas: '' });
    if (onCerrarForm) onCerrarForm();
  };

  const abrirFormularioNuevo = () => {
    setModoEdicion(false);
    setTurnoEditando(null);
    setFormData({ paciente_id: '', fecha_hora: '', duracion: 45, estado: 'pendiente', notas: '' });
    setMostrarFormLocal(true);
  };

  const editarTurno = (turno) => {
    setModoEdicion(true);
    setTurnoEditando(turno);
    
    // Formatear fecha_hora para datetime-local (YYYY-MM-DDTHH:MM)
    const fechaHora = new Date(turno.fecha_hora);
    const fechaHoraLocal = new Date(fechaHora.getTime() - fechaHora.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    
    setFormData({
      paciente_id: turno.paciente_id,
      fecha_hora: fechaHoraLocal,
      duracion: turno.duracion,
      estado: turno.estado || 'pendiente',
      notas: turno.notas || ''
    });
    setMostrarFormLocal(true);
  };

  const eliminarTurno = (turno) => {
    setTurnoAEliminar(turno);
    setMostrarConfirmEliminar(true);
  };

  const confirmarEliminar = async () => {
    try {
      await axios.delete(`/turnos/${turnoAEliminar.id}`);
      cargarDatos();
      setMostrarConfirmEliminar(false);
      setTurnoAEliminar(null);
    } catch (error) {
      console.error('Error eliminando turno:', error);
      alert('Error al eliminar el turno');
    }
  };

  const cancelarEliminar = () => {
    setMostrarConfirmEliminar(false);
    setTurnoAEliminar(null);
  };

  return (
    <div className="turnos-page">
      <div className="page-header">
        <h2>Agenda de Turnos</h2>
        <div className="header-actions">
          <button 
            className="btn-secondary"
            onClick={() => exportTurnos(turnos, 'excel')}
            title="Exportar a Excel"
          >
            📊 Excel
          </button>
          <button 
            className="btn-secondary"
            onClick={() => exportTurnos(turnos, 'pdf')}
            title="Exportar a PDF"
          >
            📄 PDF
          </button>
          <button 
            className="btn-primary"
            onClick={abrirFormularioNuevo}
          >
            📅 Nuevo Turno
          </button>
        </div>
      </div>

      <div className="filtros">
        <label>
          Filtrar por fecha:
          <input
            type="date"
            value={fechaFiltro}
            onChange={(e) => setFechaFiltro(e.target.value)}
          />
        </label>
      </div>

      {mostrarFormLocal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{modoEdicion ? 'Editar Turno' : 'Nuevo Turno'}</h3>
            <form onSubmit={handleSubmit}>
              <select
                value={formData.paciente_id}
                onChange={(e) => setFormData({...formData, paciente_id: e.target.value})}
                required
              >
                <option value="">Seleccionar paciente</option>
                {pacientes.map(paciente => (
                  <option key={paciente.id} value={paciente.id}>
                    {paciente.nombre}
                  </option>
                ))}
              </select>
              <input
                type="datetime-local"
                value={formData.fecha_hora}
                onChange={(e) => setFormData({...formData, fecha_hora: e.target.value})}
                required
              />
              <select
                value={formData.duracion}
                onChange={(e) => setFormData({...formData, duracion: parseInt(e.target.value)})}
              >
                <option value={30}>30 minutos</option>
                <option value={45}>45 minutos</option>
              </select>
              {modoEdicion && (
                <select
                  value={formData.estado}
                  onChange={(e) => setFormData({...formData, estado: e.target.value})}
                >
                  <option value="pendiente">Pendiente</option>
                  <option value="completado">Completado</option>
                  <option value="cancelado">Cancelado</option>
                  <option value="no_show">No Show</option>
                </select>
              )}
              <textarea
                placeholder="Notas del turno"
                value={formData.notas}
                onChange={(e) => setFormData({...formData, notas: e.target.value})}
                rows="3"
              />
              <div className="modal-actions">
                <button type="submit" className="btn-primary">
                  {modoEdicion ? 'Guardar Cambios' : 'Crear Turno'}
                </button>
                <button 
                  type="button" 
                  className="btn-secondary"
                  onClick={cerrarModal}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="turnos-list">
        {turnos.map(turno => (
          <div key={turno.id} className="turno-card">
            <div className="turno-info">
              <h3>{turno.paciente_nombre || 'Sin paciente'}</h3>
              <p>📅 {new Date(turno.fecha_hora).toLocaleString()}</p>
              <p>⏰ Duración: {turno.duracion} minutos</p>
              {turno.notas && <p>📝 {turno.notas}</p>}
              <span className={`estado ${turno.estado}`}>{turno.estado}</span>
            </div>
            <div className="turno-actions">
              <button 
                className="btn-icon btn-editar"
                onClick={() => editarTurno(turno)}
                title="Editar turno"
              >
                ✏️
              </button>
              <button 
                className="btn-icon btn-eliminar"
                onClick={() => eliminarTurno(turno)}
                title="Eliminar turno"
              >
                🗑️
              </button>
              <button 
                className="btn-small btn-success"
                onClick={() => cambiarEstadoTurno(turno.id, 'completado')}
                title="Marcar como completado"
              >
                ✅
              </button>
              <button 
                className="btn-small btn-warning"
                onClick={() => cambiarEstadoTurno(turno.id, 'cancelado')}
                title="Cancelar turno"
              >
                ❌
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de Confirmación de Eliminación */}
      <ConfirmDialog
        isOpen={mostrarConfirmEliminar}
        title="Eliminar Turno"
        message={`¿Deseas eliminar el turno del ${turnoAEliminar ? new Date(turnoAEliminar.fecha_hora).toLocaleDateString() : ''}?`}
        detail={`Paciente: ${turnoAEliminar?.paciente_nombre || 'N/A'}`}
        confirmText="Sí, eliminar"
        cancelText="Cancelar"
        onConfirm={confirmarEliminar}
        onCancel={cancelarEliminar}
        isDangerous={true}
      />
    </div>
  );
}

export default Turnos;
